module.exports = __webpack_public_path__ + "src/assets/textures/leaves/potato_leaf_color_map.jpg";